import { useNavigate } from '@tanstack/react-router'

import { SearchlightResultItemLayout } from './searchlightResultItemLayout'

type PageItemProps = {
  title: string
  link: string
}

export const PageItem = ({ title, link }: PageItemProps) => {
  const navigate = useNavigate()

  return (
    <SearchlightResultItemLayout
      value={title}
      searchContent={title}
      iconName="List"
      onSelect={() => {
        navigate({
          to: link,
        })
      }}
    />
  )
}
